import { Box, Grid, Stack, Switch, ToggleButton, ToggleButtonGroup, Tooltip, Typography } from "@mui/material";
import ContainerCard from "../../../components/Cards/ContainerCard";
import { useTranslation } from "react-i18next";
import { Title } from "../../../components/Titles/FormTitles";
import TextField from "../../../components/TextFields/TextField";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { setViewMode } from "../../../app/reducers/viewPreferenceSlice";
import { useSelector } from "react-redux";
import useMutationAuth from "../../../hooks/useMutationAuth";
import { GET_USER_NOTIFICATION_STATUS, RECEIVE_EMAIL_REPORTER_EMPLOYEE } from "../../../graphql/employee";
import useAuth from "../../../hooks/useAuth";
import { enqueueSnackbar } from "notistack";
import useQueryAuth from "../../../hooks/useQueryAuth";

const MyPreferences = () => {
    const { t } = useTranslation();
    const { storeUserGuid } = useAuth();
    const dispatch = useDispatch();
    const alignment = useSelector((state) => state.viewPreference.viewMode);
    const [notificationStatus, setNotificationStatus] = useState(false);

    
  const {
    data: getUserNotificationStatus,
    loading: userNotificationLoading,
    tokenChange: userNotificationWait,
  } = useQueryAuth(GET_USER_NOTIFICATION_STATUS, "GetUserByID", {
    variables: { model: { userId: storeUserGuid} },
    isWait: true,
  });
  useEffect(() => {

    if(getUserNotificationStatus) {
      setNotificationStatus(getUserNotificationStatus?.GetUserByID?.userView?.user?.receiveTaskStatusChangeNotifications);
     
      setViewMode(getUserNotificationStatus?.GetUserByID?.userView?.user?.isListView?'list':'board')
     }
  }, [getUserNotificationStatus,alignment]);
  
    const handleAlignment = (event, newAlignment) => {
       
        editUserReceiveNotification(
            {
              variables: {
                model: {
                    employeeGuid: storeUserGuid,
                    isListView: newAlignment=='list', 
                },
              },
            },
            (response) => {
              if (
                response["EditUserQuick"].errorCode !== null &&
                response["EditUserQuick"].errorCode !== ""
              ) {
                enqueueSnackbar(t(response["EditUserQuick"].errorMessage), {
                  variant: "error",
                  autoHideDuration: 5000
                });
               
              } else {
                if (newAlignment !== null) {
                    dispatch(setViewMode(newAlignment));
                }
                enqueueSnackbar(t("Default view changes successfully"), {
                  variant: "success",
                });
              }
            }
          );
    };

    const { cfunction: editUserReceiveNotification, loading: loadingReception } = useMutationAuth(RECEIVE_EMAIL_REPORTER_EMPLOYEE, "EditUserQuick");

    const changeNotificationStatus = (status) => {
        editUserReceiveNotification(
            {
              variables: {
                model: {
                    employeeGuid: storeUserGuid,
                    receiveTaskStatusChangeNotifications: status, 
                },
              },
            },
            (response) => {
              if (
                response["EditUserQuick"].errorCode !== null &&
                response["EditUserQuick"].errorCode !== ""
              ) {
                enqueueSnackbar(t(response["EditUserQuick"].errorMessage), {
                  variant: "error",
                  autoHideDuration: 5000
                });
              } else {
                enqueueSnackbar(t("Status changes successfully"), {
                  variant: "success",
                });
              }
            }
          );
    };

    // Corrected onChange function that passes the new status value
    const handleSwitchChange = (event) => {
        const status = event.target.checked;
        setNotificationStatus(status);
        changeNotificationStatus(status); // Update the mutation with the new status
    };

    return (
        <Box mb={5} >
            <Grid
                container
                justifyContent="left"
                alignItems="stretch"
                sx={{ height: "100%", mt: 2 }}
                spacing={2}
            >
                <Grid
                    item
                    xs={12}
                    sm={12}
                    sx={{ display: "flex", flexDirection: "column", gap: "20px" }}
                >
                    <ContainerCard>
                        <Box p={2}>
                            <Box>
                                <Grid container spacing={2} alignItems="center">
                                    <Grid item xs={12}>
                                        <Title>{t('Choose Preferences')}</Title>
                                    </Grid>
                                    <Grid item xs={12} container alignItems="center" spacing={2}>
                                        <Grid item>
                                            <Typography>{t('Select Default Backlog View')}</Typography>
                                        </Grid>
                                        <Grid item>
                                            <Stack direction="row" spacing={4}>
                                                <ToggleButtonGroup
                                                    value={alignment}
                                                    onChange={handleAlignment}
                                                    exclusive
                                                    aria-label="text alignment"
                                                    style={{ height: '40px' }}
                                                >
                                                    <Tooltip value="board" title={t('Board View')} placement="top">
                                                        <ToggleButton value="board" aria-label="left aligned">
                                                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" width="24" height="24" stroke-width="2">
                                                                <path d="M4 4l6 0"></path>
                                                                <path d="M14 4l6 0"></path>
                                                                <path d="M4 8m0 2a2 2 0 0 1 2 -2h2a2 2 0 0 1 2 2v8a2 2 0 0 1 -2 2h-2a2 2 0 0 1 -2 -2z"></path>
                                                                <path d="M14 8m0 2a2 2 0 0 1 2 -2h2a2 2 0 0 1 2 2v2a2 2 0 0 1 -2 2h-2a2 2 0 0 1 -2 -2z"></path>
                                                            </svg>
                                                        </ToggleButton>
                                                    </Tooltip>
                                                    <Tooltip value="list" title={t('List View')} placement="top">
                                                        <ToggleButton value="list" aria-label="centered">
                                                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" width="24" height="24" stroke-width="2">
                                                                <path d="M9 6h11"></path>
                                                                <path d="M12 12h8"></path>
                                                                <path d="M15 18h5"></path>
                                                                <path d="M5 6v.01"></path>
                                                                <path d="M8 12v.01"></path>
                                                                <path d="M11 18v.01"></path>
                                                            </svg>
                                                        </ToggleButton>
                                                    </Tooltip>
                                                </ToggleButtonGroup>
                                            </Stack>
                                        </Grid>
                                    </Grid>
                                    <Grid item xs={12} container alignItems="center" spacing={2}>
                                        <Grid item>
                                            <Typography>{t('Receive notification email when status is changed')}</Typography>
                                        </Grid>
                                        <Grid item>
                                            <Stack direction="row" spacing={4}>
                                                <Switch
                                                    checked={notificationStatus}
                                                    onChange={handleSwitchChange} // Updated to use the new handler
                                                    inputProps={{ 'aria-label': 'controlled' }}
                                                />
                                            </Stack>
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Box>
                        </Box>
                    </ContainerCard>
                </Grid>
            </Grid>
        </Box>
    )
}

export default MyPreferences;
